import {
  buttonWhite,
  buttonOrange,
  whiteShades,
  transparentColors
} from '@assets/styles/helpers/colors.styles'

export const getIconButtonStyles = (
  color: 'primary' | 'secondary' | 'tertiary',
  variant: 'text' | 'contained' = 'text'
) => {
  if (variant === 'contained') {
    switch (color) {
      case 'primary':
        return {
          backgroundColor: buttonWhite.contained.background,
          border: 'none',
          color: buttonWhite.contained.font,
          '&:hover': {
            backgroundColor: buttonWhite.contained.backgroundHover
          },
          '&:active': {
            backgroundColor: buttonWhite.contained.backgroundActive
          },
          '&.Mui-disabled': {
            backgroundColor: buttonWhite.contained.backgroundDisabled,
            color: buttonWhite.contained.font
          }
        }
      case 'secondary':
        return {
          backgroundColor: buttonOrange.contained.background,
          border: 'none',
          color: buttonOrange.contained.font,
          '&:hover': {
            backgroundColor: buttonOrange.contained.backgroundHover
          },
          '&:active': {
            backgroundColor: buttonOrange.contained.backgroundActive
          },
          '&.Mui-disabled': {
            backgroundColor: buttonOrange.contained.backgroundDisabled,
            color: buttonOrange.contained.font
          }
        }
      case 'tertiary':
        return {
          backgroundColor: whiteShades.shade4,
          border: 'none',
          color: whiteShades.shade1,
          '&:hover': {
            backgroundColor: whiteShades.shade3,
            color: whiteShades.shade2
          },
          '&:active': {
            backgroundColor: whiteShades.shade2,
            color: whiteShades.shade3
          },
          '&.Mui-disabled': {
            backgroundColor: whiteShades.shade4,
            color: whiteShades.shade4
          }
        }
      default:
        return {}
    }
  }

  switch (color) {
    case 'primary':
      return {
        backgroundColor: buttonWhite.text.background,
        border: 'none',
        color: buttonWhite.text.font,
        '&.Mui-disabled': {
          color: buttonWhite.text.fontDisabled
        },
        '&:hover': {
          color: buttonWhite.text.fontHover
        },
        '&:active': {
          color: buttonWhite.text.fontActive
        }
      }
    case 'secondary':
      return {
        backgroundColor: buttonOrange.text.background,
        border: 'none',
        color: buttonOrange.text.font,
        '&:hover': {
          color: buttonOrange.text.fontHover
        },
        '&:active': {
          color: buttonOrange.text.fontActive
        },
        '&.Mui-disabled': {
          color: buttonOrange.text.fontDisabled
        }
      }
    case 'tertiary':
      return {
        backgroundColor: transparentColors.transparent,
        border: 'none',
        color: whiteShades.shade1,
        '&:hover': {
          color: whiteShades.shade2
        },
        '&:active': {
          color: whiteShades.shade3
        },
        '&.Mui-disabled': {
          color: whiteShades.shade4
        }
      }
    default:
      return {}
  }
}
